import { inject, InjectOptions, Type } from '@angular/core'

export class RootInjectorGuard {
  option: InjectOptions = {
    skipSelf: true,
    optional: true,
  }
  constructor(type: Type<unknown>) {
    const parent = inject(type, this.option)
    if (parent) {
      throw Error(
        `[${type.name}]: A service that should be a singleton is attempting to be instantiated again.`,
      )
    }
  }
}
